import { asyncModalAdapter } from 'App/helpers/angularPortingHelpers';

export const openSharedViewsModal = asyncModalAdapter({
	upModalName: 'sharedViewsModal',
	openModalName: 'SharedViewsModal',
	featureFlag: 'REACT_SHARED_VIEWS_MODAL'
});
